// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeViewDetailSection-RemoteIDRow_cls1__Io0eF","cls2":"PayeeViewDetailSection-RemoteIDRow_cls2__LTFxv PayeeViewDetailSection-RemoteIDRow_cls1__Io0eF"};